import map from './VmgMap'
import StartEventHook from './StartEventHook'
import Logger from '../Log'

const Log = Logger.for('PassbackHook')

export default class PassbackStartHook extends StartEventHook {
  constructor () {
    super('PassbackHook')
  }

  async run (remoteConfig) {
    const zoneId = remoteConfig.zoneId()

    const bid = {
      ad: null,
      width: null,
      height: null,
      cpm: 0,
      requestId: 'passback',
      mediaType: 'banner'
    }
    switch (zoneId) {
      case 'NvLJE4ohz6IfMCcY3wes': // broward, missing pb
        break
      case 'kXVzPMr8HTkIYiED7mFp': // dallas
        bid.width = 300
        bid.height = 250
        bid.ad = '<script language="JavaScript" type="text/javascript">\n' +
          'rp_account   = \'8065\';\n' +
          'rp_site      = \'13038\';\n' +
          'rp_zonesize  = \'212700-15\';\n' +
          'rp_adtype    = \'js\';\n' +
          'rp_smartfile = \'[SMART FILE URL]\';\n' +
          '</script>\n' +
          '<script type="text/javascript" src="http://ads.rubiconproject.com/ad/8065.js"></script>\n' +
          '<!--  End Rubicon Project Tag -->'
        break
      case 'fKaK8orSPDjOUYHhSTpA': // houston
        bid.width = 300
        bid.height = 250
        bid.ad = '<!--  Begin Rubicon Project Tag -->\n' +
          '<!--  Site: Voice Media Group   Zone: Houston Press   Size: Medium Rectangle  -->\n' +
          '<!--  PLACEMENT: Above the Fold;   -->\n' +
          '<script language="JavaScript" type="text/javascript">\n' +
          'rp_account   = \'8065\';\n' +
          'rp_site      = \'13038\';\n' +
          'rp_zonesize  = \'212704-15\';\n' +
          'rp_adtype    = \'js\';\n' +
          'rp_smartfile = \'[SMART FILE URL]\';\n' +
          '</script>\n' +
          '<script type="text/javascript" src="http://ads.rubiconproject.com/ad/8065.js"></script>\n' +
          '<!--  End Rubicon Project Tag -->'
        break
      case '3DyK8tSIf1ivNjUE8Kp5': // miami
        bid.width = 300
        bid.height = 250
        bid.ad = '<!--  Begin Rubicon Project Tag -->\n' +
          '<!--  Site: Voice Media Group   Zone: Miami New Times   Size: Medium Rectangle  -->\n' +
          '<!--  PLACEMENT: Above the Fold;   -->\n' +
          '<script language="JavaScript" type="text/javascript">\n' +
          'rp_account   = \'8065\';\n' +
          'rp_site      = \'13038\';\n' +
          'rp_zonesize  = \'212724-15\';\n' +
          'rp_adtype    = \'js\';\n' +
          'rp_smartfile = \'[SMART FILE URL]\';\n' +
          '</script>\n' +
          '<script type="text/javascript" src="http://ads.rubiconproject.com/ad/8065.js"></script>\n' +
          '<!--  End Rubicon Project Tag -->'
        break
      case 'DoENsEj3jJ8SoIjuB69k': // phoenix
        bid.width = 300
        bid.height = 250
        bid.ad = '<!--  Begin Rubicon Project Tag -->\n' +
          '<!--  Site: Voice Media Group   Zone: Phoenix New Times   Size: Medium Rectangle  -->\n' +
          '<!--  PLACEMENT: Above the Fold;   -->\n' +
          '<script language="JavaScript" type="text/javascript">\n' +
          'rp_account   = \'8065\';\n' +
          'rp_site      = \'13038\';\n' +
          'rp_zonesize  = \'212696-15\';\n' +
          'rp_adtype    = \'js\';\n' +
          'rp_smartfile = \'[SMART FILE URL]\';\n' +
          '</script>\n' +
          '<script type="text/javascript" src="http://ads.rubiconproject.com/ad/8065.js"></script>\n' +
          '<!--  End Rubicon Project Tag -->'
        break
      case 'jpCsFLmT5n1IqQJs5dtD': // westword
        bid.width = 300
        bid.height = 250
        bid.ad = '<!--  Begin Rubicon Project Tag -->\n' +
          '<!--  Site: Voice Media Group   Zone: Denver Westword   Size: Medium Rectangle  -->\n' +
          '<!--  PLACEMENT: Above the Fold;   -->\n' +
          '<script language="JavaScript" type="text/javascript">\n' +
          'rp_account   = \'8065\';\n' +
          'rp_site      = \'13038\';\n' +
          'rp_zonesize  = \'212708-15\';\n' +
          'rp_adtype    = \'js\';\n' +
          'rp_smartfile = \'[SMART FILE URL]\';\n' +
          '</script>\n' +
          '<script type="text/javascript" src="http://ads.rubiconproject.com/ad/8065.js"></script>\n' +
          '<!--  End Rubicon Project Tag -->'
        break
      case '5Kv1tsAM4hxP6rdUmYlW': // tempo
        bid.width = 320
        bid.height = 100
        bid.ad = '<!-- 320x100/320x50 -->\n' +
          '<script src=\'https://www.googletagservices.com/tag/js/gpt.js\'>\n' +
          '  googletag.pubads().definePassback(\'/21710144538/dr-mp-rs-tempo.co-d-tsf-320x50\', [[320, 50]]).set("page_url", "tempo.co").display();\n' +
          '</script>\n' +
          '\n' +
          '<script>\n' +
          '  console.log ("SmarRTB_Streamlyn-320x50");\n' +
          '  </script>\n' +
          '  <!-- END --> '
        break
      case 'KGPpMUarDKZjhwBbgvPW': // tempo
        bid.width = 300
        bid.height = 250
        bid.ad = '<!-- 300x250 -->\n' +
          '<script src=\'https://www.googletagservices.com/tag/js/gpt.js\'>\n' +
          '  googletag.pubads().definePassback(\'/14056285/passbacktag/pb_all_tempo_300x250\', [300, 250]).display();\n' +
          '</script>\n' +
          '\n' +
          '<script>\n' +
          'console.log ("SmartRTB-Pb-All-Tempo-300x250");\n' +
          '</script>' +
          '  <!-- END -->  '
        break
      case 'm6EiDiFKVUzxYrV2iXzS': // tempo
        bid.width = 728
        bid.height = 90
        bid.cpm = 2
        bid.adUnitCode = '123'
        bid.bidder = 'testguy'
        bid.ad = '<!-- 970x90/728x90 -->\n' +
          '<script src=\'https://www.googletagservices.com/tag/js/gpt.js\'>\n' +
          '  googletag.pubads().definePassback(\'/21710144538/dr-dp-rs-tempo.co-d-tsf-970x90\', [970, 90]).set("page_url", "tempo.co").display();\n' +
          '</script>\n' +
          '\n' +
          '<script>\n' +
          '  console.log ("SmartRTB_Streamlyn-970x90");\n' +
          '</script>\n' +
          '<!-- END -->'
        break
      default:
        // some other tag idc
    }

    if (bid.ad) {
      map.passback(bid)
      Log.debug('Registered VMG or Tempo passback')
    }
  }
}
